//
// Copyright 2025 DXOS.org
//

// @import-as-namespace

import { ThemePlugin } from '#plugin';

export { meta } from '#meta';

/** Constructs the plugin; the body is loaded eagerly. */
export const make = ThemePlugin;
